import { useEffect, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { LocationDeskProvider, useLocationDeskContext } from './context/LocationDeskContext';
import { getCurrentUserId } from '../../services/LocationCashController';
import DeskSelectionView from './DeskSelectionView';
import ActiveDeskView from './ActiveDeskView';
import MovementsHistoryView from './components/MovementsHistoryView';
import './LocationDeskView.scss';

function LocationDeskContent() {
    const { currentView, setCurrentUserId } = useLocationDeskContext();
    const [initialLoading, setInitialLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        async function checkExistingSession() {
            try {
                const userId = await getCurrentUserId();
                if (cancelled) return;
                setCurrentUserId(userId);

            } catch (err) {
                console.error('Error checking existing session:', err);
            }
            if (!cancelled) {
                setInitialLoading(false);
            }
        }

        checkExistingSession();
        return () => { cancelled = true; };
    }, []);

    if (initialLoading) {
        return (
            <div className="flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <ProgressSpinner />
            </div>
        );
    }

    return (
        <div className="viewContainer bg-white pd-4 location-desk-view">
            {currentView === 'selection' && <DeskSelectionView />}
            {currentView === 'active' && <ActiveDeskView />}
            {currentView === 'movements' && <MovementsHistoryView />}
        </div>
    );
}

export default function LocationDeskView() {
    return (
        <LocationDeskProvider>
            <LocationDeskContent />
        </LocationDeskProvider>
    );
}
